import { render, staticRenderFns } from "./JiaotongTongdaFenxi.vue?vue&type=template&id=6e5f59ca&scoped=true&"
import script from "./JiaotongTongdaFenxi.vue?vue&type=script&lang=js&"
export * from "./JiaotongTongdaFenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f59ca",
  null
  
)

export default component.exports